export default __webpack_public_path__ + "static/media/psychiatry.a9f9f9c8.png";